import { render, staticRenderFns } from "./AudioEditPanel.vue?vue&type=template&id=840e062e&scoped=true&"
import script from "./AudioEditPanel.vue?vue&type=script&lang=js&"
export * from "./AudioEditPanel.vue?vue&type=script&lang=js&"
import style0 from "./AudioEditPanel.vue?vue&type=style&index=0&id=840e062e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840e062e",
  null
  
)

export default component.exports